import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getAssetTypeCategories(currUserId) {
        const url = `${config.cloudFunctionsBaseUrl}/getAssetTypeCategories`;
        return axios.post(url, {
            currUserId: currUserId
        });
    },
}
